/**
 * Google Analytics 4 (gtag.js) — client component.
 *
 * Loads the GA4 measurement snippet **only** when a valid
 * `NEXT_PUBLIC_GA_MEASUREMENT_ID` env var is set (production builds).
 */
'use client';

import Script from 'next/script';
import { Capacitor } from '@capacitor/core';

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export function GoogleAnalytics() {
  if (!GA_ID) return null;

  // 'web' | 'ios' | 'android' — lets one GA4 property be sliced by platform.
  const platform = Capacitor.getPlatform();

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="lazyOnload"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());` +
          // event-scoped param on every subsequent event + user-scoped property
          `gtag('set',{platform:'${platform}'});` +
          `gtag('set','user_properties',{platform:'${platform}'});` +
          `gtag('config','${GA_ID}');`}
      </Script>
    </>
  );
}
